import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { RacingUrlParam } from '@frontend/sports/racing/feature/models';
import { TabsGroupSizesType } from '@frontend/ui/tabsgroup';

import { AdaptiveLayoutState } from '../../../layout/adaptive-layout.service';
import { UrlHelperService } from '../../../navigation-core/url-helper.service';
import { SubNavigationResolve } from '../../../sub-navigation/sub-navigation-resolve.service';
import { SubNavigationItem } from '../../../sub-navigation/sub-navigation.models';

enum HorseTabType {
    Today = 1,
    Tomorrow,
    FutureSpecials,
}

@Injectable()
export class HorsesSubNavigationService extends SubNavigationResolve<any> {
    constructor(
        private sitecore: Sitecore,
        private urlHelper: UrlHelperService,
    ) {
        super();
    }

    buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot, model: any): void {
        const routeTag = routeSnapshot.data && routeSnapshot.data.tag ? routeSnapshot.data.tag : null;

        if (!routeTag) {
            this.tabs$.next([]);
            this.size$.next('' as TabsGroupSizesType);

            return;
        }

        this.tabs$.next(this.getDefaultTabs(routeTag));
        this.size$.next('large');
    }

    private getDefaultTabs(routeTag: RouteTag): SubNavigationItem[] {
        return [
            {
                icon: '',
                title: this.sitecore.horseRacing.navigation.Today,
                url: this.urlHelper.getRaceUrl(SportConstant.Horses, RacingUrlParam.Today),
                active: routeTag === RouteTag.RacingToday,
                id: HorseTabType.Today,
                ignoreBrowserHistory: true,
            },
            {
                icon: '',
                title: this.sitecore.horseRacing.navigation.Tomorrow,
                url: this.urlHelper.getRaceUrl(SportConstant.Horses, RacingUrlParam.Tomorrow),
                active: routeTag === RouteTag.RacingTomorrow,
                id: HorseTabType.Tomorrow,
                ignoreBrowserHistory: true,
            },
            {
                icon: '',
                title: this.sitecore.horseRacing.navigation.FutureAndSpecials,
                url: this.urlHelper.getRaceUrl(SportConstant.Horses, RacingUrlParam.Future),
                active: routeTag === RouteTag.RacingFuture,
                id: HorseTabType.FutureSpecials,
                ignoreBrowserHistory: true,
            },
        ];
    }
}
